import logoFFD from '@assets/images/logo-ffd.png';
import logoND from '@assets/images/logo-nd.png';
import logoZP from '@assets/images/logo-zp.png';

export enum PROJECT_NAME {
  BK = 'BK',
  ND = 'ND',
  FFD = 'FFD',
}

export const projects = [
  {
    id: PROJECT_NAME.BK,
    webApiUrl: process.env.REACT_APP_BK_WEB_API_URL ?? '',
    adminApiUrl: process.env.REACT_APP_BK_ADMIN_API_URL ?? '',
    iconSrc: logoZP,
  },
  {
    id: PROJECT_NAME.ND,
    webApiUrl: process.env.REACT_APP_ND_WEB_API_URL ?? '',
    adminApiUrl: process.env.REACT_APP_ND_ADMIN_API_URL ?? '',
    iconSrc: logoND,
  },
  {
    id: PROJECT_NAME.FFD,
    webApiUrl: process.env.REACT_APP_FFD_WEB_API_URL ?? '',
    adminApiUrl: process.env.REACT_APP_FFD_ADMIN_API_URL ?? '',
    iconSrc: logoFFD,
  },
];
